import React, { useMemo } from "react";

import BracketHeader from "./tableauElimination/BracketHeader";
import BracketLegend from "./tableauElimination/BracketLegend";
import BracketBoard from "./tableauElimination/BracketBoard";

import SystematicRepechageBoard from "./tableauRepechageSystematique/SystematicRepechageBoard";
import BronzeBoard from "./tableauRepechageSystematique/BronzeBoard";

import {
  buildMainRoundsForSystematicRepechage,
  buildSystematicRepechageData,
  getSystematicRepechageStats,
} from "./tableauRepechageSystematique/systematicRepechageUtils";

const TableauSystematiqueRepechage = ({
  competiteurs = [],
  combats = [],
  roundNames = [],
  firstRoundSeed = [],
  onOpenCreate,
  onOpenEdit,
  onOpenScoreboard,
}) => {
  const seed =
    Array.isArray(firstRoundSeed) && firstRoundSeed.length
      ? firstRoundSeed
      : competiteurs;

  const mainRounds = useMemo(
    () =>
      buildMainRoundsForSystematicRepechage({
        seed,
        competiteurs,
        combats,
        roundNames,
      }),
    [seed, competiteurs, combats, roundNames],
  );

  const repechageData = useMemo(
    () =>
      buildSystematicRepechageData({
        mainRounds,
        combats,
      }),
    [mainRounds, combats],
  );

  const stats = useMemo(
    () =>
      getSystematicRepechageStats({
        seed,
        mainRounds,
        repechageData,
      }),
    [seed, mainRounds, repechageData],
  );

  return (
    <section className="mt-8 w-full">
      <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-[0_18px_55px_rgba(15,23,42,0.08)] dark:border-white/10 dark:bg-slate-950">
        <BracketHeader stats={stats} />

        <BracketLegend />

        <div className="border-b border-slate-200 bg-white px-5 py-4 dark:border-white/10 dark:bg-slate-950">
          <h3 className="text-lg font-bold text-slate-900 dark:text-white">
            Tableau principal
          </h3>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            Les vainqueurs avancent dans le tableau principal. Les perdants
            avant les demi-finales sont orientés vers les tableaux de repêchage.
          </p>
        </div>

        <BracketBoard
          seed={seed}
          rounds={mainRounds}
          onOpenCreate={onOpenCreate}
          onOpenEdit={onOpenEdit}
          onOpenScoreboard={onOpenScoreboard}
        />

        <SystematicRepechageBoard
          repechageA={repechageData.repechageA}
          repechageB={repechageData.repechageB}
          onOpenCreate={onOpenCreate}
          onOpenEdit={onOpenEdit}
          onOpenScoreboard={onOpenScoreboard}
        />

        <BronzeBoard
          bronzeA={repechageData.bronzeA}
          bronzeB={repechageData.bronzeB}
          onOpenCreate={onOpenCreate}
          onOpenEdit={onOpenEdit}
          onOpenScoreboard={onOpenScoreboard}
        />
      </div>
    </section>
  );
};

export default TableauSystematiqueRepechage;